import { forwardRef } from 'react';

import classNames from 'classnames';
import {
  Button as RACButton,
  type ButtonProps as RACButtonProps,
} from 'react-aria-components/Button';

import styles from './button_base.module.css';

export type ButtonBaseProps = RACButtonProps & {
  className?: string;
};

/**
 * A thin wrapper around react-aria-components Button with all visual styling removed.
 * Provides only accessibility + interaction behavior. You supply every style.
 *
 * See https://react-spectrum.adobe.com/react-aria/Button.html for the underlying
 * implementation.
 *
 * ```tsx
 * <ButtonBase>
 *  Click me!
 * </ButtonBase>
 * ```
 */
export const ButtonBase = forwardRef<HTMLButtonElement, ButtonBaseProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <RACButton
        ref={ref}
        {...props}
        className={classNames(styles.button, className)}
      >
        {children}
      </RACButton>
    );
  },
);
